// The control plane's agent documents, each served as a page here at
// /{name} (server/src/docs.js renders them; pages/Doc.tsx shows them) as
// well as /{name}.md on the control plane. The same names as docs.js's
// AGENT_DOCS; `label` is the footer's link text (SKILL.md is always called
// that, as in the nav).

export interface AgentDoc {
  name: string;
  label: string;
}

export const AGENT_DOCS: AgentDoc[] = [
  { name: 'skill', label: 'SKILL.md' },
  { name: 'instances', label: 'Instances' },
  { name: 'credits', label: 'Credits' },
  { name: 'replicas', label: 'Replicas' },
  { name: 'container', label: 'Isolation' },
  { name: 'changelog', label: 'Changelog' },
];
